export const transformDate = (d?: string | null, year?: string | null) =>
  year ? year : d ? d.split("-")[0] : undefined;
